import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }
const _hoisted_2 = { class: "text-wrap text-body-medium text-sm-body-large font-weight-medium heading-row-gap w-75" }
const _hoisted_3 = { class: "text-body-small pt-1" }
const _hoisted_4 = { class: "d-flex justify-space-between align-center" }
const _hoisted_5 = { class: "text-body-large" }

export function render(_ctx, _cache) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_card_title = _resolveComponent("v-card-title")
  const _component_v_divider = _resolveComponent("v-divider")
  const _component_v_sheet = _resolveComponent("v-sheet")
  const _component_v_chip = _resolveComponent("v-chip")
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")
  const _component_expandable_element = _resolveComponent("expandable-element")
  const _component_v_list_item = _resolveComponent("v-list-item")
  const _component_v_list = _resolveComponent("v-list")
  const _component_v_card = _resolveComponent("v-card")
  const _component_v_menu = _resolveComponent("v-menu")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_menu, {
      location: "bottom right",
      width: 340,
      "max-height": 600,
      "close-on-content-click": false
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps(props, {
          icon: "",
          flat: "",
          size: "40",
          onClick: _ctx.onClickPushMessagesBell
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              color: _ctx.unreadWebpushMessages ? 'blue' : 'grey lighten-1',
              size: "34"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" mdi-bell ", -1)
              ]))]),
              _: 1
            }, 8, ["color"])
          ]),
          _: 1
        }, 16, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('app.webpush.pushmessages')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_list, {
              flat: "",
              class: "push-message-list-left-rim"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: date }, [
                    _createVNode(_component_v_sheet, {
                      rounded: "",
                      color: "primary",
                      class: "text-center font-weight-medium py-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.formatDateWithLocale(date, _ctx.$i18n.locale)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getWebPushMessagesAtDate(date), (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: item.id
                      }, [
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createVNode(_component_v_list_item_title, { class: "mt-1 d-flex w-100" }, {
                                default: _withCtx(() => [
                                  (!item.read)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        color: "blue",
                                        "text-color": "white",
                                        size: "small",
                                        class: "mr-1 px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('app.new')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getLocalTimeOfMessage(item)), 1)
                            ]),
                            _createVNode(_component_expandable_element, {
                              baseHeight: 80,
                              class: _normalizeClass(["text-body-small text-sm-body-medium mt-2", { 'text-row-gap': _ctx.mobileXs }])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.text), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_divider, { class: "my-2" })
                      ], 64))
                    }), 128))
                  ], 64))
                }), 128)),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    flat: "",
                    disabled: _ctx.webPushMessagesPage <= 1,
                    onClick: _ctx.decreaseWebPushMessagesPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "large",
                        color: _ctx.webPushMessagesPage <= 1 ? 'grey' : 'blue'
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" mdi-arrow-left-bold-circle-outline ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('app.webpush.page', {page: _ctx.webPushMessagesPage, maxPage:
            _ctx.webPushMessagesMaxPage})), 1),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    flat: "",
                    disabled: _ctx.webPushMessagesPage >= _ctx.webPushMessagesMaxPage,
                    onClick: _ctx.increaseWebPushMessagesPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "large",
                        color: _ctx.webPushMessagesPage >= _ctx.webPushMessagesMaxPage ? 'grey' : 'blue'
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode(" mdi-arrow-right-bold-circle-outline ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}